import React, { Component, PropTypes } from 'react';

const HotelGenericPropertyValue = ({ hotel }) => {
    return (
        <div className="hotel-generic-property-value">
            <div className="hotel-id-name-property-value">
                <div className="hotel-id-property-value">{hotel.id}</div>
                <div className="hotel-name-property-value">{hotel.name}</div>
            </div>
            <div>Optional Component</div>
        </div>
    );
};

export default HotelGenericPropertyValue;



// WEBPACK FOOTER //
// ./src/components/modals/HotelGenericPropertyValue.js